

import React, { useEffect } from 'react';
import './Home_story.css';
import AOS from 'aos';

const Home_story = () => {
 useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    AOS.refresh();
  }, []);

  return (
    <div className="story-master-container">
      {/* ── Section 1: Hero Image & Philosophy (Combined) ── */}
      <section className="story-hero-wrapper">
        <div className="story-hero-overlay"></div>
        <div className="container story-hero-inner">
          
          {/* Main Title Section */}
          <div className="story-hero-text text-center" data-aos="zoom-out">
            <h1 className="story-display-title"> Stories</h1>
            <p className="story-hero-subtitle">Where every product has a reason, and every choice has a story.</p>
          </div>

          {/* Philosophy Section (Right below the Hero text) */}
          <div className="story-philosophy-content text-center" data-aos="fade-up" data-aos-delay="300">
            <span className="story-tagline">OUR PHILOSOPHY</span>
            <h2 className="story-philosophy-heading">Beyond Just Content</h2>
            <p className="story-philosophy-text">
              Garshya Stories is a window into the "why" behind what we offer. 
              Nothing is random—every product, every service, and every detail is chosen with intention.
            </p>
            <div className="story-simple-line"></div>
          </div>

        </div>
      </section>

      {/* ── Section 2: Features/Pillars Grid ── */}
      <div className="container py-5">
        <div className="row g-4 story-cards-row">
          <div className="col-md-6 col-lg-3" data-aos="fade-up" data-aos-delay="0" data-aos-once="false">
            <div className="story-pillar-box">
              <i className="bi bi-search"></i>
              <h4>Product Logic</h4>
              <p>We evaluate the core value and technical thought behind every item.</p>
            </div>
          </div>
          <div className="col-md-6 col-lg-3" data-aos="fade-up" data-aos-delay="0" data-aos-once="false">
            <div className="story-pillar-box">
              <i className="bi bi-stars"></i>
              <h4>Curated Picks</h4>
              <p>Moving beyond viral trends to spotlight reliable and refined selections.</p>
            </div>
          </div>
          <div className="col-md-6 col-lg-3" data-aos="fade-up" data-aos-delay="0" data-aos-once="false">
            <div className="story-pillar-box">
              <i className="bi bi-shield-check"></i>
              <h4>Real Value</h4>
              <p>Focusing on how products integrate into your life, not just how they look.</p>
            </div>
          </div>
          <div className="col-md-6 col-lg-3" data-aos="fade-up" data-aos-delay="0" data-aos-once="false">
            <div className="story-pillar-box">
              <i className="bi bi-gear-wide-connected"></i>
              <h4>Our Process</h4>
              <p>Revealing the filters and standards we apply for every curation.</p>
            </div>
          </div>
        </div>

        {/* ── Section 3: Bottom Banner ── */}
        <div className="story-final-banner text-center banner-story" data-aos-delay="0" data-aos-once="false">
           <h3>More Than Just Shopping</h3>
           <p>
             Built for those who want to understand before they choose. 
             We value clarity over confusion and quality over quantity.
           </p>
           <div className="story-banner-divider"></div>
        </div>
      </div>
    </div>
  );
};

export default Home_story;